import Vue from 'vue';
import 'echarts';
import VChart from 'vue-echarts';

Vue.component('VChart', VChart);
